import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { EmailValidator } from '../../tools/email-validator';
import { ALERT_BUTTONS_MESSAGES, ALERT_MESSAGES } from 'src/app/core/constants/AlertMessages';
import { Payment, Transaction } from 'src/app/models';
import { AlertService } from 'src/app/services/alert.service';
import { DepositsManageService } from 'src/app/services/deposits-manage.service';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { ALERT_ICON_CONSTANTS, AUTOCOMPLETE_FORM_CONTROLS, AUTOCOMPLETE_METHOD_PAY_TYPES, FLAGS_NAME } from 'src/app/core/constants/General-constants';
import { SweetAlertIcon } from 'sweetalert2';
import { ASSETS_CONSTANTS } from 'src/app/core/constants/Assets-constants';
import { EMAIL_LENGTH } from 'src/app/constants/users.constants';
import { ALERT_ERRORS, EMAIL_VALIDATION } from 'src/app/core/constants/Errors';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { PatchValAdditionalInfoService } from 'src/app/services/patch-val-additional-info.service';

@Component({
  selector: 'app-deuna-ecuador',
  templateUrl: './deuna-ecuador.component.html',
  styleUrls: ['./deuna-ecuador.component.css'],
})
export class DeunaEcuadorComponent {
  @Input() info: Payment;
  @Output() DEUNA = new EventEmitter();
  transaction: Transaction;
  loading: boolean;
  template: string;
  deuna_logo: string = ASSETS_CONSTANTS.DEUNA_LOGO;
  formPrivacyValid: boolean;
  buttonEnabled: boolean;
  buttonStateChange: any;
  emailForm: any;
  attemps: any;
  errorMessages = EMAIL_VALIDATION;
  isEditableInfo: boolean = false;
  walletsAutoCompleteFF: boolean = false;
  objectControlData = [
    {
      formControl: 'email',
      readOnly: false,
    },
  ];

  constructor(
    private readonly tokenServiceService: TokenServiceService,
    private readonly depositManager: DepositsManageService,
    private readonly alertService: AlertService,
    private readonly formBuilder: FormBuilder,
    private featureFlagService: PayvalidaFeatureFlagService,
    private readonly patchValAdditionalInfoService: PatchValAdditionalInfoService,
  ) {
    this.emailForm = this.formBuilder.group({
      email: [
        '',
        Validators.compose([Validators.required,
        EmailValidator.isValid,
        Validators.maxLength(EMAIL_LENGTH.MAX),
        ]),
      ],
    });
  }

  ngOnInit(): void {
    this.template = this.info.template;
    this.loading = false;
    this.transaction = this.tokenServiceService.getAndDecodeToken();
    const additionalInfo = this.tokenServiceService.exitsAdditionalInformation(this.transaction);

    this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.WALLETS_AUTOCOMPLETE_FF, FLAGS_NAME.WALLETS_AUTOCOMPLETE_FF)
      .subscribe( (response: boolean) => {
        this.walletsAutoCompleteFF = response;

        if (additionalInfo && this.walletsAutoCompleteFF) return this.disabledItems(additionalInfo);
      });
  }

  /**
   *
   * @description {isControlReadOnly} function to check if form fields are read-only
   * @param controlName
   * @returns
   */
  isControlReadOnly(controlName: string): boolean {
    const readOnlyControl = this.objectControlData.find((m) => m.formControl === controlName);

    return readOnlyControl ? readOnlyControl.readOnly : false;
  }

  /**
  *
  * @description {disabledItems} Function to disabled items to checkout form
  */
  disabledItems(additionalInfo) {
    try {
      this.isEditableInfo = this.tokenServiceService.isEditableInfo(additionalInfo);

      return this.patchValAdditionalInfoService.patchValAdditionalInfo(
        this.isEditableInfo,
        additionalInfo,
        this.emailForm,
        AUTOCOMPLETE_METHOD_PAY_TYPES.DEUNA,
        this.objectControlData,
      );
    } catch (_) {
      this.alertService.showAlert(ALERT_ERRORS.GET_TOKEN_DATA_ERROR);
    }
  }

  /**
   * @description {sendEmail} Function to send transaction email with rate limit
   */
  sendEmail() {
    this.loading = true;

    if (this.emailForm.valid) {
      this.depositManager
        .sendEmailWithLimit(this.transaction.ORDER_CODE.toString(), this.email)
        .subscribe({
          next: (response) => {
            if (response) {
              this.alertService.showPopup(
                ALERT_MESSAGES.EMAIL_SENT,
                ALERT_MESSAGES.EMAIL_SENT_MESSAGE,
                ALERT_ICON_CONSTANTS.SUCCESS as SweetAlertIcon,
                ALERT_BUTTONS_MESSAGES.THANKS
              );

              this.loading = false;

              return;
            }
            this.alertService.showAlertProblem();
          },
          error: () => {
            this.loading = false;

            this.alertService.showPopup(
              ALERT_MESSAGES.EMAIL_NOT_SENT,
              ALERT_MESSAGES.EMAIL_NOT_SENT_RATE_LIMIT,
              ALERT_ICON_CONSTANTS.ERROR as SweetAlertIcon,
              ALERT_BUTTONS_MESSAGES.THANKS
            );
          },
        });
    }
  }

  /**
 * @description Gets the current value of the email field in the form.
 * @returns {string} Current value of the email.
 */
  get email() {
    return this.emailForm.get(AUTOCOMPLETE_FORM_CONTROLS.EMAIL).value;
  }

  /**
 * @description Consults the number of deposit attempts for the current order.
 * Updates the 'attempts' property and the 'loading' property during the query.
 * @returns
 */
  consultDepositAttemps() {
    this.loading = true;

    this.depositManager
      .consultOrder(this.transaction.ORDER_CODE.toString())
      .subscribe((res: any) => {
        this.attemps = res.attemps;
        this.loading = false;
      });
  }

  /**
   *
   * @description {formPrivacyUpdate} Function that obtains the event of the validation of the child component
   * @param valid
   */
  formPrivacyUpdate(valid: boolean) {
    this.formPrivacyValid = valid;
  }

  /**
   *
   * @description {completedForms} Function to validate the validations of the parent component and child component
   * @returns
   */
  completedForms = (): boolean => {
    return this.formPrivacyValid && this.emailForm.valid;
  };

  /**
 * @description changes the pay method and emits a DEUNA event.
 * @returns
 */
  changeMethod() {
    this.DEUNA.emit();
  }
}
